<template>
  <!-- 国内机票退票 -->
  <div style="width:100%">
    <div class="content-info">
      <h4 class="fs15">订单信息</h4>
      <div class="content-info_text fs12">
        <span>订单号：{{detailData.orderNo}}</span>
        <span>订单状态：{{detailData.orderStatusText}}</span>
        <span>PNR：{{detailData.pnr}}</span>
        <span>预定时间：{{detailData.orderTime}}</span>
        <span>出票时间：{{detailData.ticketTime}}</span>
        <span>订单总价：￥{{detailData.amount}}</span>
        <span>支付方式：{{detailData.payTypeText}}</span>
        <span>交易时间：{{detailData.payTime}}</span>
      </div>
    </div>
    <div class="content-list">
      <h2>乘客/航程信息</h2>
      <div v-for="(flight,index) in detailData.refundRerationList" :key="index">
        <div class="passenger-list fs13">
          <span>乘客姓名：{{flight.passenger.psgName}}</span>
          <span>乘客类型：{{flight.passenger.psgTypeText}}</span>
          <span>证件类型：{{flight.passenger.cardTypeText}}</span>
          <span>证件号码：{{flight.passenger.cardNo}}</span>
        </div>
        <el-table
          ref="multipleTable"
          :data="flight.segmentList"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="(val)=>selectFlight(val,index)"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="航段" width="80" prop="segmentTypeText"></el-table-column>
          <el-table-column label="航空公司">
            <template slot-scope="scope">{{ scope.row.airlineName }}</template>
          </el-table-column>
          <el-table-column label="航班号">
            <template slot-scope="scope">{{ scope.row.flightNo }}</template>
          </el-table-column>
          <el-table-column label="舱位">
            <template slot-scope="scope">{{ scope.row.cabinCode }}</template>
          </el-table-column>
          <el-table-column label="起抵地">
            <template slot-scope="scope">
              <p>
                {{scope.row.sCityName + scope.row.sAirportCode}} -
                {{scope.row.eCityName + scope.row.eAirportCode}}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="起飞时间" width="100">
            <template slot-scope="scope">
              {{ scope.row.beginDate}}
              {{scope.row.beginTime}}
            </template>
          </el-table-column>
          <el-table-column label="到达时间" width="100">
            <template slot-scope="scope">
              {{ scope.row.arriveDate}}
              {{scope.row.arriveTime}}
            </template>
          </el-table-column>
          <el-table-column label="成人票号" v-if="$route.query.psgType==2">
            <template slot-scope="scope">
              <span
                style="color:#237dc8;cursor:pointer"
                @click="goPage(scope.row.adultOrderNo)"
              >{{scope.row.aduTicketNumber|| '----'}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="content-list">
      <h2>申请内容</h2>
      <div class="changing_box fs14">
        <div class="apply-list flex-center-start">
          <span>
            <sup>*</sup>退票类型：
          </span>
          <div style="width:80%">
            <el-select v-model="formData.refundType" placeholder="" size="medium">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="apply-list">
          <span>
            <sup>*</sup>座位情况：
          </span>
          <el-radio-group v-model="formData.seatStatus">
            <el-radio :label="1">请保留座位</el-radio>
            <el-radio :label="2">系统帮我取消座位</el-radio>
            <el-tooltip effect="dark" content="请再次核实座位是否已取消，因座位取消时间对退票退款有影响，请知晓。" placement="right">
              <el-radio :label="3">座位已取消</el-radio>
            </el-tooltip>
          </el-radio-group>
        </div>
        <div class="apply-list flex-center-start">
          <span>延误/病退证明：</span>
          <el-upload
            class="upload-demo"
            action=""
            :http-request="uploadImg"
            :before-upload="detectionImg"
            :on-remove="removeImg"
            multiple
            :limit="3"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">（支持jpg、png、bmp格式，文件小于500k，最多上传3张凭证）</div>
          </el-upload>
        </div>
        <div class="apply-list flex-center-start">
          <span>备注：</span>
          <el-input type="textarea" :rows="5" placeholder="" v-model="formData.remark"></el-input>
        </div>
      </div>
    </div>
    <div class="content-list">
      <h2>退票说明</h2>
      <div class="mb20 fs14" style="padding:10px 25px;">
        <p class="mt10 mb10">1、平台退改工作时间:8：30 ~ 22：00（周一至周日）请您提交改签时尽量在工作时段内提交，避免产生损失；</p>
        <p class="mt10 mb10">2、改签相关费用提交申请后，由专属客服与您联系确认。</p>
      </div>
    </div>
  </div>
</template>
<script>
import upLoadImg from "@/lib/data-service/default/web_common_upload_aptitudeSingleImage";

export default {
  name: "RefundTicket",
  data() {
    return {
      tableData: [],
      segmentList: {},
      options: [
        {
          value: 1,
          label: "自愿退票(按客规收取退票手续费)"
        },
        {
          value: 2,
          label: "航班延误或取消"
        },
        {
          value: 3,
          label: "升舱换开"
        },
        {
          value: 4,
          label: "因病无法乘机"
        },
        {
          value: 5,
          label: "其他退票情况"
        }
      ],
      radio: "",
      value: "",
      textarea: "",
      formData: {
        orderNo: this.detailData.orderNo,
        passengerList: [],
        refundType: null,
        remark: "",
        seatStatus: 1,
        url: "",
        batchFlag: 0
      },
      fileImg: []
    };
  },
  watch: {
    formData: {
      deep: true,
      handler: function(newV, oldV) {
        console.log(newV);
        this.$emit("getData", newV);
      }
    },
      detailData: {
        deep: true,
          handler: function(newV, oldV) {
              let formData = this.formData
              formData.orderNo = newV.orderNo
              this.formData = formData
          }
      }
  },
  props: ["detailData"],
  methods: {
    uploadImg(file) {
      upLoadImg(file.file).then(res => {
        this.fileImg.push({ url: res.fileList[0], uid: file.file.uid });
        this.getUrl(this.fileImg);
      });
    },
    goPage(val) {
      if (!val) return;
      this.$router.push({
        name: "air-ticket-admin-international-list-detail",
        query: { ordersNo: val }
      });
    },
    selectFlight(val, index) {
      this.segmentList[index] = val;
      var passengerList = (arr = []) => {
        if (!arr instanceof Array) return;
        return arr.map(item => {
          let list = {
            psgNo: item[0].psgId,
            segmentNoList: item.map(items => items.segmentId)
          };
          return list;
        });
      };
      this.formData.passengerList = passengerList(
        Object.values(this.segmentList).filter(item => item.length)
      );
    },
    getUrl(val) {
      let url = val.map(item => {
        return item.url;
      });
      this.formData.url = url.join(",");
    },
    detectionImg(file) {
      var reg2 = /^(\s|\S)+(jpg|png|bmp)+$/;
      const isLt2M = file.size / 1024 < 500;
      if (!reg2.test(file.name)) {
        this.$message({ type: "warning", message: "图片格式上传错误！" });
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 500K!");
        return false;
      }
    },
    removeImg(file) {
      this.fileImg.map((item, index) => {
        item.uid == file.uid ? this.fileImg.splice(index, 1) : "";
      });
      this.getUrl(this.fileImg);
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/lib/deprecated/styles/common.less";

.content-list {
  @contentBox();
  h5 {
    padding: 10px 25px;
    font-weight: 300;
  }
  .el-table {
    font-size: 13px;
  }
}
.content_table {
  @contentTable();
}
.changing_box {
  padding: 10px 25px;
  color: @ftText;
  .changing_msg {
    display: flex;
    align-items: stretch;
  }
  .apply-list {
    display: flex;
    align-items: stretch;
    position: relative;
    sup {
      color: red;
      position: absolute;
      top: 10px;
      left: 20px;
    }
    padding: 10px 0;
    span {
      min-width: 100px;
      text-align: right;
    }

    /deep/.el-select {
      width: 100%;
      .el-input__inner {
        border-radius: 0;
      }
    }
  }
}
.el-button {
  border-radius: 0;
}
.content-info {
  border: 1px solid #ffb27f;
  h4 {
    background: #fff5ef;
    padding: 8px 25px;
    font-weight: 400;
  }
  &_text {
    display: flex;
    flex-flow: wrap;
    background: #fffcfa;
    padding: 15px 25px;
    span {
      width: 25%;
      display: block;
      padding: 6px 0;
    }
  }
}
.passenger-list {
  padding: 10px 25px;
  background: #ecf6ff6e;
  border-bottom: 1px dashed #dfdfdf;
  span {
    padding-right: 40px;
  }
}
</style>
<style>
.el-tooltip__popper.is-dark {
  background: #ecf6ff !important;
  color: #ff6600 !important;
}
.el-tooltip__popper[x-placement^="right"] .popper__arrow {
  display: none !important;
}
</style>
